import { Row, Stack } from '@christiankaindl/lyts'
import { type ReactNode } from 'react'
import Text from '../Text/Text'
import * as styles from './ListBox.css'

interface Props {
  title: string
  /** Displayed below the title */
  subTitle?: string | ReactNode
  suffix?: ReactNode
}

export default function ListBoxRow ({ title, subTitle, suffix }: Props) {
  return (
    <Row xAlign='space-between' className={styles.row} wrap gap={0.25}>
      <Stack gap={0}>
        <Text weight={500} size='0.9em'>
          {title}
        </Text>
        {subTitle && (
          <Text color='secondary' size='0.9em' style={{ wordBreak: 'break-word' }}>
            {subTitle}
          </Text>
        )}
      </Stack>
      {typeof suffix === 'string'
        ? (
          <Text color='secondary' size='0.9em'>
            {suffix}
          </Text>
          )
        : suffix}
    </Row>
  )
}
